import { getRequest, postRequest } from '../baseRequest'

// 查询菜单列表
export const getMenuList = (data) => getRequest('/common/getAllMenu',data)

// 分页查询角色列表
export const getRoleList = (data) => postRequest('/role/getRoles',data)

// 查询全部角色列表
export const getRoleListAll = (data) => getRequest('/role/getAllRoles',data)

// 查询角色详细
export const getRoleDetail = (id) => getRequest('/role/getRoleAuth/' + id)

// 新增角色
export const addRole = (data) => postRequest('/role/createRole', data)

// 修改角色
export const updateRole = (data) => postRequest('/role/updateRole', data)

// 禁用角色
export const deactivateRole = (id) => getRequest('/role/deactivateRole/'+id)

// 启用角色
export const activateRole = (id) => getRequest('/role/activateRole/'+id)
